module.exports = __webpack_public_path__ + "img/SKMJ_M2.052458ca.png";